module["exports"] = ["ge", "com", "net", "org", "com.ge", "org.ge"];